import React, { useMemo } from 'react';
import { Select } from 'antd';
import { gql } from '@apollo/client';
import { useQuery } from 'hooks/apollo';

const QUERY = gql`
  query($type: SurveyType!) {
    surveyTemplates(type: $type) { id title surveys { id language } }
  }
`;

const SurveyTemplateSelect = ({ type, language, ...props }) => {
  const { loading, data: { surveyTemplates = [] } = {} } = useQuery(QUERY, {
    variables: { type },
    skip: !type,
  });

  const options = useMemo(() => [
    { value: '', label: 'Empty survey' },
    ...surveyTemplates.filter(t => t.surveys.some(s => s.language === language)).map(c => ({ value: c.id, label: c.title })),
  ], [surveyTemplates, language]);

  return (
    <Select loading={loading} options={options} showSearch optionFilterProp="label" {...props} />
  );
};

export default SurveyTemplateSelect;
